window._ = require('lodash'); // npm install lodash --save
window.axios = require("axios"); // npm install axios --save
window.Aos = require("aos"); // npm install aos --save
window.smoothscroll = require('smoothscroll-polyfill'); // npm install smoothscroll-polyfill --save
// window.jarallax = require('jarallax'); // npm install jarallax --save
window.lightgallery = require('lightgallery.js'); // npm install lightgallery.js --save

window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
